import React from "react";
import { Card, CardContent } from "@material-ui/core";

class PaymentSuccess extends React.Component {
  render() {
    return (
      <Card>
        <CardContent>Payment was successfull</CardContent>
      </Card>
    );
  }
}

export default PaymentSuccess;



// WEBPACK FOOTER //
// ./src/views/Payment/PaymentSuccess.jsx